import { takeEvery, put, call } from "redux-saga/effects";
import { types } from "../reducers/dashboard";
import { DashboardService } from "../../services";
import { formatErrors } from "../../helpers/ErrorFormater";

function* getPmeWithFilters({ payload, callback }) {
  const obj = Object.keys(payload).reduce((all, key) => {
    const d = payload[key];
    if (key === 'filters') {
      if (d !== null && typeof d === 'object' && Object.keys(d).length) {
        all[key] = d;
        return all;
      }
      return all;
    }
    all[key] = d;
    return all;
  }, {});

  try {
    if (typeof payload?.setLoading === 'function') {
      payload?.setLoading(true);
    }
    const {
      data,
    } = yield call(() => DashboardService.getPmeDashboard(obj));
    if (data) {
      callback(true);
    }
    yield put({ type: types.PME_DASHBOARD_SUCCESS, value: data });
  } catch (e) {
    const formattedErrors = formatErrors(e)
    callback(false);
    yield put({
      type: types.PME_DASHBOARD_FAILED,
      value: formattedErrors,
    });
  }
  if (typeof payload?.setLoading === 'function') {
    payload?.setLoading(false);
  }
}

function* getCaddWithFilters({ payload, callback, isScpProject }) {
  if (isScpProject) {
    try {
      const {
        data,
      } = yield call(() => DashboardService.getCaddDashboardScp(payload));
      if (data) {
        if (typeof callback === 'function') {
          callback(true);
        }
      }
      yield put({ type: types.CADD_DASHBOARD_SUCCESS, value: { [payload.widget]: data[payload.widget] } });
    } catch (e) {
      const formattedErrors = formatErrors(e)
      if (typeof callback === 'function') {
        callback(false);
      }
      yield put({
        type: types.CADD_DASHBOARD_FAILED,
        value: formattedErrors,
      });
    }

  } else {
    try {
      const {
        data,
      } = yield call(() => DashboardService.getCaddDashboard(payload));
      if (data) {
        if (typeof callback === 'function') {
          callback(true);
        }
      }
      yield put({ type: types.CADD_DASHBOARD_SUCCESS, value: { [payload.widget]: data[payload.widget] } });
    } catch (e) {
      const formattedErrors = formatErrors(e)
      if (typeof callback === 'function') {
        callback(false);
      }
      yield put({
        type: types.CADD_DASHBOARD_FAILED,
        value: formattedErrors,
      });
    }
  }
}
function* getCadd({ isScpProject, selectedProject }) {
  try {
    const {
      data,
    } = yield call(() =>
      isScpProject ? DashboardService.getCaddDashboardScp({ project: selectedProject }) : DashboardService.getCaddDashboard());
    yield put({ type: types.CADD_DASHBOARD_SUCCESS, value: data });
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.CADD_DASHBOARD_FAILED,
      value: formattedErrors,
    });
  }
}

function* getPme({ callback }) {
  try {
    const {
      data,
    } = yield call(() => DashboardService.getPmeDashboard());
    yield put({ type: types.PME_DASHBOARD_SUCCESS, value: { ...data } });
    callback(true);
  } catch (e) {
    const formattedErrors = formatErrors(e)
    callback(false);
    yield put({
      type: types.PME_DASHBOARD_FAILED,
      value: formattedErrors,
    });
  }
}

function* getPmeProject({ callback }) {
  try {
    const {
      data,
    } = yield call(() => DashboardService.getPmeProject());
    yield put({ type: types.PME_PROJECT_SUCCESS, value: data });
    callback(true);
  } catch (e) {
    const formattedErrors = formatErrors(e)
    yield put({
      type: types.PME_PROJECT_FAILED,
      value: formattedErrors,
    });
    callback(false);
  }
}

function* getPmeProjectWithFilters({ payload, callback }) {
  try {
    if (typeof payload?.setLoading === 'function') {
      payload?.setLoading(true);
    }
    const {
      data,
    } = yield call(() => DashboardService.getPmeProject(payload));
    yield put({
      type: types.PME_PROJECT_SUCCESS,
      value: data,
    });
    if (data) {
      callback(true);
    }
  } catch (e) {
    const formattedErrors = formatErrors(e)
    callback(false);
    yield put({
      type: types.PME_PROJECT_FAILED,
      value: formattedErrors,
    });
  }
  if (typeof payload?.setLoading === 'function') {
    payload?.setLoading(false);
  }
}

export default function* init() {
  yield takeEvery(
    types.CADD_DASHBOARD_REQUEST,
    getCadd,
  );
  yield takeEvery(
    types.PME_DASHBOARD_REQUEST,
    getPme,
  );
  yield takeEvery(
    types.PME_DASHBOARD_REQUEST_WITH_FILTERS,
    getPmeWithFilters,
  );
  yield takeEvery(
    types.CADD_DASHBOARD_REQUEST_WITH_FILTERS,
    getCaddWithFilters,
  );
  yield takeEvery(
    types.PME_PROJECT_REQUEST,
    getPmeProject,
  );
  yield takeEvery(
    types.PME_PROJECT_REQUEST_WITH_FILTERS,
    getPmeProjectWithFilters,
  );
}
